import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './components/AnalyticsTracker';
import FloatingContact from './components/FloatingContact';
import Landing from './pages/Landing';
import About from './pages/About';
import AboutHistory from './pages/about/History';
import AboutFounder from './pages/about/Founder';
import AboutClients from './pages/about/Clients';
import Products from './pages/Products';
import OurPlant from './pages/OurPlant';
import Contact from './pages/Contact';
import TradeFairs from './pages/TradeFairs';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import WhatsAppFab from './components/WhatsAppFab';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App bg-[#faf6f0] min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <Navbar />
        <main className="pt-24 md:pt-28">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/history" element={<AboutHistory />} />
            <Route path="/about/founder" element={<AboutFounder />} />
            <Route path="/about/clients" element={<AboutClients />} />
            <Route path="/products" element={<Products />} />
            <Route path="/our-plant" element={<OurPlant />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/trade-fairs" element={<TradeFairs />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <FloatingContact />
        <WhatsAppFab />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
